<template>
<div>
  <v-container
    grid-list-md
    fluid
    fill-height
  >
    <v-layout
      row
      wrap
    >
      <v-flex xs12>

        <v-progress-linear
          color="carregando"
          v-show="loading"
          :indeterminate="true"
        ></v-progress-linear>

          <v-card
            v-show="mostraConvenios"
            class="Black--text"
            color="card"
          >

            <v-card-title primary-title>
              <div class=" .pa-1 text-md-left headline">Movimentação por Lojas</div>
            </v-card-title>
            <v-card-title>
              <v-flex>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="140"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dataInFormatted"
                    label="Data Inicial"
                    readonly
                    color="info"
                    header-color="primary"
                    persistent-hint
                    prepend-icon="event"
                    @blur="dataIn = parseDate(dataInFormatted)"
                  ></v-text-field>
                    <v-date-picker
                      locale="pt-br"
                      v-model="dataIn"
                      no-title
                      @input="menu = false"
                    ></v-date-picker>
                      </v-menu>
              </v-flex>

              <v-flex>
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dataFimFormatted"
                    label="Data Final"
                    color="info"
                    header-color="primary"
                    persistent-hint
                    prepend-icon="event"
                    @blur="dataFim = parseDate(dataFimFormatted)"
                  ></v-text-field>
                    <v-date-picker
                      locale="pt-br"
                      v-model="dataFim"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                      </v-menu>
              </v-flex>

              <v-flex>
                <v-btn
                  class="white--text"
                  @click="filtrar()"
                  color="sucesso"
                  value="justify"
                >
                  Filtrar
                  <v-icon right="">filter_list</v-icon>
                  </v-btn>
              </v-flex>
              <v-flex>
                <v-btn
                  class="white--text"
                  @click="buscaLojasPdf()"
                  id="btnPDF"
                  ref="btnPDF"
                  color="orange"
                  value="justify"
                >
                  PDF
                  <v-icon right>tab</v-icon>
                  </v-btn>
              </v-flex>
              <v-spacer></v-spacer>
            </v-card-title>
           <vue-good-table
              :columns="columns"
              :rows="items"
              :search-options="{                  
                  placeholder: 'Buscar na tabela',
                  enabled: true
                }"
              :groupOptions="{
              enabled: true
            }"
              :pagination-options="{
              enabled: true,
              setCurrentPage: 1,
              perPage: 10 ,
              perPageDropdown: [10, 20, 30],
              dropdownAllowAll: true,
              ofLabel: 'de',
              allLabel: 'Todos',
              nextLabel: 'Proximo',
              prevLabel: 'Anterior',
              rowsPerPageLabel: 'linhas por pagina',
              }"
            >
            <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'estorno'">

              <v-btn v-if="parseFloat(props.row.valor) > 0" small class="white--text" color="terciary" @click.native="estornar(props.row.hash)">Estornar</v-btn>
              <span class="pl-1" style="font-weight: bolder;" v-if="props.row.tipo=='Estorno'">
                Estornado</span>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
              <div slot="emptystate">
                Nenhum dado retornado
              </div>
              </vue-good-table>
             <!-- <v-data-table
                v-show="false"
                :items="items"
                :loading="false"
                :search="search"
                rows-per-page-text="registros por página"
                no-data-text="Nenhum resultado encontrado!"
                no-results-text="Nenhum resultado encontrado!"
                class="elevation-3"
              >
                <template
                  slot="headerCell"
                  slot-scope="props"
                >
                  <v-tooltip bottom>
                    <span slot="activator">
                        {{ props.header.text }}
                        </span>
                    <span>
                        {{ props.header.text }}
                        </span>
                  </v-tooltip>
                  </template>
                  <template
                    slot="items"
                    slot-scope="props"
                  >
                    <td class="text-xs-left">{{ props.item.data }}</td>
                    <td class="text-xs-left">{{ props.item.loja }}</td>
                    <td class="text-xs-rigth">{{ formata_moeda(props.item.valor) }}</td>
                    <td class="text-xs-left">{{ props.item.identificacao }}</td>
                    
                    <span v-if="props.column.field == 'action'">
                    <button class="fancy-btn">Action</button>
                  </span>

                    </template>
                    
                    <template
                      slot="pageText"
                      slot-scope="{ pageStart, pageStop }"
                    >
                      de{{ pageStart }} até {{ pageStop }}
                      </template>
                      </v-data-table>-->
                      </v-card>
      </v-flex>
      <a href="#" target="_blank" id="linkDownload" download></a>
      </v-layout>
      </v-container>
      <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Estornar movimentação</v-card-title>
        <v-card-text>Confirma a estorno dessa movimentação?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white--text" @click.native="dialogDelete = false">Cancela</v-btn>
          <v-btn
            color="success"
            class="white--text"
            @click.native="confirmaEstorno();dialogDelete = false"
          >Confirma</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import { HTTP } from "../services/http.axios";
import { formata } from "../services/format";

var moment = require("moment");

export default {
  mixins: [formata],
  mounted() {
    this.buscaExtratoCartao(this.dataIn, this.dataFim);
  },
  data: () => ({
    dialogDelete:false,
    dataIn: moment().format("YYYY-MM-01"),
    extrato: [],
    search: "",
    loading: false,
    mostraConvenios: false,
    dataInFormatted: moment().format("01/MM/YYYY"),
    menu: false,
    menu2: false,
    dataFim: moment().format("YYYY-MM-DD"),
    dataFimFormatted: moment().format("DD/MM/YYYY"),

    columns: [
      {
        label: "Data",
        field: "data"
      },
      {
        label: "Cartão",
        field: "num_cartao"
      },
      {
        label: "Valor",
        field: "valor",
        type: "number"
      },
      {
        label: " ",
        field: "sinalop"
      },
      {
        label: " ",
        field: "estorno"
      },
      
    ],
  
    items: []
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.dataIn);
    }
  },

  watch: {
    dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
    },
    dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
    }
  },

  methods: {
    estornar(item){
     this.setHash = item;
     this.dialogDelete = true;
    },
    confirmaEstorno(){

      HTTP.post(`movimentacao/estornar`, {'hash':this.setHash})
        .then(response => {
          
          this.filtrar()
        })
        .catch(e => {
          // console.log("erros:::::" + e.response.data.errors);
          console.log(e.response.data.error);
          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }
           
          }
        });

    },
    fieldFn(rowObj) {
      console.log(rowObj);
      return rowObj.operacao;
      if (rowObj.operacao == "C") {
        return "positivo";
      } else {
        return "negativo";
      }
    },
    filtrar() {
      this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda(val) {
      let val1 = val / 100;
      let valor = this.formatar_moeda(val1);
      return valor;
    },

    buscaLojasPdf() {
      this.loading = true;
      HTTP.get(
        `movimentacao/loja/pdf` + "/" + this.dataIn + "/" + this.dataFim
      ).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          document.getElementById("linkDownload").href = response.data.url;
          document.getElementById("linkDownload").click();
        }
        this.loading = false;
      });
    },
    buscaExtratoCartao(dataIn, dataFim) {
      this.loading = true;
      HTTP.get(`movimentacao/loja` + "/" + dataIn + "/" + dataFim).then(
        response => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            //this.extrato =
            console.log(response.data);
            this.items = response.data;
            this.mostraConvenios = true;
          }
          this.loading = false;
        }
      );
    },

    //mudar para um mixed
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>

<style>
#container {
  margin-top: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/Lojas.vue